import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Authentication failed - no session found");
        navigate("/");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session via backend
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUser(response.data);
        toast.success("Welcome to MyDoor360!");
        
        // Navigate to dashboard with user data
        navigate("/dashboard", { state: { user: response.data }, replace: true });
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/");
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C04000] mx-auto"></div>
        <p className="mt-4 text-slate-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
